module.exports = __webpack_public_path__ + "static/media/logo170.ab774660.png";